'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import './AddNutrients.scss';
import './RemoveNutrients.scss';
import modalStyles from '../../../../../jsx-styles/modals';
import allNutrients from '../../../../../tables/nutrients';

export default class RemoveNutrients extends Component {

    static propTypes = {
        onRemoveNutrients: PropTypes.func.isRequired,
        currentNutrients: PropTypes.array,
        buttonClass: PropTypes.string,
        modalStyle: PropTypes.string,  // 'pro' or 'admin'
    };

    static defaultProps = {
        currentNutrients: [],
        buttonClass: null,
        modalStyle: 'pro',
    };

    static contextTypes = {
        showUpgradeForm: PropTypes.func,
        user: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.state = {
            search: '',
            selectedNutrients: [],
            isModalOpen: false,
            isConfirmRemove: false,
        };
    }

    showModal = () => {
        this.setState({isModalOpen: true});
    }

    closeModal = () => {
        this.setState({
            isModalOpen: false,
            isConfirmRemove: false,
            selectedNutrients: [],
            search: ''
        });
    }

    toggleNutrient = (nutrNo) => {
        const { selectedNutrients } = this.state;

        const i = selectedNutrients.indexOf(nutrNo);

        if (i === -1) {
            selectedNutrients.push(nutrNo);
        } else {
            selectedNutrients.splice(i, 1);
        }

        this.setState({selectedNutrients});
    }

    matchFilters = (nutrNo) => {
        const { currentNutrients = [] } = this.props;
        const { search } = this.state;

        // Nutrient must be in current nutrients
        if (!currentNutrients.includes(nutrNo)) {
            return false;
        }

        // Must have valid nutrient info
        if (!(allNutrients[nutrNo] && allNutrients[nutrNo].Filter)) {
            return false;
        }

        // Apply search filter
        if (search) {
            const searchLower = search.toLowerCase();
            const nutrientName = allNutrients[nutrNo].NutrDesc.toLowerCase();
            const nutrientNo = nutrNo.toLowerCase();
            return nutrientName.includes(searchLower) || nutrientNo.includes(searchLower);
        }

        return true;
    }

    handleRemove = () => {
        const { selectedNutrients } = this.state;
        if (selectedNutrients.length > 0) {
            this.setState({isConfirmRemove: true});
        }
    }

    confirmRemove = () => {
        const { onRemoveNutrients } = this.props;
        const { selectedNutrients } = this.state;
        onRemoveNutrients(selectedNutrients);
        this.closeModal();
    }

    cancelConfirm = () => {
        this.setState({isConfirmRemove: false});
    }

    renderAdminModal = () => {
        const { isConfirmRemove, search, selectedNutrients } = this.state;

        const alphaSortCmp = (a, b) => allNutrients[a].NutrDesc.localeCompare(allNutrients[b].NutrDesc);
        const nutrients = Object.keys(allNutrients)
                                .filter(this.matchFilters)
                                .sort(alphaSortCmp);

        if (isConfirmRemove) {
            return (
                <Modal isOpen={true}
                    onRequestClose={this.cancelConfirm}
                    className="el-modal el-modal2"
                    overlayClassName="el-modal-overlay"
                    contentLabel="Confirm Removal"
                    closeTimeoutMS={250}>

                    <div className="el-modal-container el-modal2-container remove-nutrients-confirm-modal">
                        <header>
                            <h2>Confirm Removal</h2>
                            <button className="el-modal-close-x" onClick={this.cancelConfirm}>
                                <i className="icon-close-x" />
                                <span className="assistive-text">Close Modal</span>
                            </button>
                        </header>

                        <div className="el-modal-body-container">
                            <div className="confirm-remove-content">
                                <i className="icon-trash-can" />
                                <h3>Remove the following nutrients?</h3>
                                <ul className="nutrients-to-remove">
                                    {selectedNutrients.map(nutrNo => (
                                        <li key={nutrNo}>{allNutrients[nutrNo].NutrDesc}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        <footer>
                            <button
                                className="el-modal-cancel-btn"
                                onClick={this.cancelConfirm}
                            >
                                Cancel
                            </button>
                            <button
                                className="el-modal-ok-btn el-modal-danger-btn"
                                onClick={this.confirmRemove}
                            >
                                Remove
                            </button>
                        </footer>
                    </div>
                </Modal>
            );
        }

        return (
            <Modal isOpen={true}
                onRequestClose={this.closeModal}
                className="el-modal el-modal2"
                overlayClassName="el-modal-overlay"
                contentLabel="Remove Nutrients"
                closeTimeoutMS={250}>

                <div className="el-modal-container el-modal2-container remove-nutrients-modal remove-nutrients-modal-admin">
                    <header>
                        <h2>Remove Nutrients</h2>
                        <button className="el-modal-close-x" onClick={this.closeModal}>
                            <i className="icon-close-x" />
                            <span className="assistive-text">Close Modal</span>
                        </button>
                    </header>

                    <div className="el-modal-body-container">
                        <div className="el-labeled-input el-input-with-icon el-search-input">
                            <i className="icon-search3 left-icon" />
                            <input
                                type="text"
                                placeholder="Search nutrients..."
                                value={search}
                                onChange={ev => this.setState({search: ev.target.value})}
                            />
                        </div>

                        <div className="nutrients-list-container">
                            {nutrients.length > 0 ? (
                                <ul className="nutrients-list">
                                    {nutrients.map(nutrNo => (
                                        <li key={nutrNo}>
                                            <button
                                                className="el-checkbox"
                                                data-active={selectedNutrients.includes(nutrNo)}
                                                onClick={() => this.toggleNutrient(nutrNo)}
                                            >
                                                {allNutrients[nutrNo].NutrDesc}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <div className="no-results">
                                    <p>
                                        {search
                                            ? 'No matching nutrients found'
                                            : 'No nutrients available to remove'
                                        }
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>

                    <footer>
                        <button
                            className="el-modal-cancel-btn"
                            onClick={this.closeModal}
                        >
                            Cancel
                        </button>
                        <button
                            className="el-modal-ok-btn"
                            onClick={this.handleRemove}
                            disabled={selectedNutrients.length === 0}
                        >
                            Remove Selected
                        </button>
                    </footer>
                </div>
            </Modal>
        );
    }

    renderProModal = () => {
        const { isConfirmRemove, search, selectedNutrients } = this.state;

        const alphaSortCmp = (a, b) => allNutrients[a].NutrDesc.localeCompare(allNutrients[b].NutrDesc);
        const nutrients = Object.keys(allNutrients)
                                .filter(this.matchFilters)
                                .sort(alphaSortCmp);

        if (isConfirmRemove) {
            return (
                <Modal isOpen={true}
                    onRequestClose={this.cancelConfirm}
                    closeModal={this.cancelConfirm}
                    className="add-remove-nutrients-modal"
                    contentLabel="Confirm Removal"
                    style={modalStyles.largeSquareModal}
                    closeTimeoutMS={250}>

                    <div className="add-remove-nutrients-container remove-nutrients-container editor-modal-container">
                        <header className="modal-header">
                            <h2>Confirm Removal</h2>
                            <button className="close-btn" onClick={this.cancelConfirm}>
                                <i className="icon-close-x" />
                                <span className="assistive-text">Close Modal</span>
                            </button>
                        </header>

                        <div className="confirm-remove">
                            <i className="icon-trash-can" />
                            <h2>Confirm Removal of:</h2>

                            {selectedNutrients.map(nutrNo => {
                                return <span key={nutrNo}>{allNutrients[nutrNo].NutrDesc}</span>
                            })}
                        </div>

                        <footer>
                            <button className="cancel" onClick={this.cancelConfirm}>Cancel</button>
                            <button className="accept" onClick={this.confirmRemove}>Remove</button>
                        </footer>
                    </div>
                </Modal>
            );
        }

        return (
            <Modal isOpen={true}
                onRequestClose={this.closeModal}
                closeModal={this.closeModal}
                className="add-remove-nutrients-modal"
                contentLabel="Remove Nutrients"
                style={modalStyles.largeSquareModal}
                closeTimeoutMS={250}>

                <div className="add-remove-nutrients-container remove-nutrients-container editor-modal-container">
                    <header className="modal-header">
                        <h2>Remove Nutrients</h2>
                        <button className="close-btn" onClick={this.closeModal}>
                            <i className="icon-close-x" />
                            <span className="assistive-text">Close Modal</span>
                        </button>
                    </header>

                    <div className="editor-scrollable">
                        <ul>
                            {nutrients.map(nutrNo => {
                                return (
                                    <li key={nutrNo}>
                                        <label className="global-search-checkbox">
                                            <input type="checkbox" checked={selectedNutrients.includes(nutrNo)}
                                                onChange={e => this.toggleNutrient(nutrNo)} />
                                            <span>{allNutrients[nutrNo].NutrDesc}</span>
                                        </label>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>

                    <footer>
                        <button className="cancel" onClick={this.closeModal}>Cancel</button>
                        <button className="accept" onClick={this.handleRemove}>Remove</button>
                    </footer>
                </div>
            </Modal>
        );
    }

    renderRemoveNutrientsModal = () => {
        const { isModalOpen } = this.state;

        if (!isModalOpen) {
            return null;
        }

        return this.props.modalStyle == 'pro' ? this.renderProModal() : this.renderAdminModal();
    }

    render() {
        let { buttonClass } = this.props;

        const isAdmin = this.context.user?.role === 'admin';

        if (!buttonClass) {
            buttonClass = this.props.modalStyle == 'pro'
            ? 'nutrient-btn'
            : 'el-medium-btn el-raspberry-outline-btn el-btn-icon-left';
        }

        return (
            <span className="add-remove-nutrients remove-nutrients">
                <button className={buttonClass} onClick={this.showModal}>
                    <i className="icon-minus-thin" />
                    Remove Nutrient
                </button>

                {this.renderRemoveNutrientsModal()}
            </span>
        );
    }
}
